module.exports = __webpack_public_path__ + "assets/AirbnbCereal-Book.f2a450086ad604368ec711fafbf61b7b.woff2";